/**
 * Stack routes of the native screens added by the `extras1` admin-module group.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'ExtrasDataScreen', component: lazyScreen(() => import('../../screens/adminModules/extras1/ExtrasDataScreen'))},
    {name: 'ExtrasTableQrScreen', component: lazyScreen(() => import('../../screens/adminModules/extras1/ExtrasTableQrScreen'))},
];

export default ROUTES;
